module.exports = __webpack_public_path__ + "static/hero-insights-b424147bb06a835c8de410d9aab73e2b.svg";